<template>
  <b-form-group
    label="Adres"
    label-for="url"
  >
    <validation-provider
      #default="{ errors }"
      name="Adres"
      rules="required"
    >
      <b-form-input
        id="url"
        v-model="itemData.url"
        placeholder="https://www.google.com.tr/"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'ModLeadsUrlText',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['modLeads/dataItem']
    },
  },
}
</script>
